import React, { useMemo } from 'react'
import { Html, Line } from '@react-three/drei'
import { params } from '../../../../../../redux/reducers/reducer';

const OutLineSection = () => {

    const offsetCB = 0.2;
    const offsetHor = 0.15;
    const offsetVer = 0.2;
    const railWidth = 0.2

    const offset = useMemo(() => {
        if(params.backLeanStoragePosition > 0 && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) return railWidth;
        else return 0
    }, [params.backLeanStoragePosition, params.leanB_p_d, params.add_storage_back])

    const topLinePoints = useMemo(() => (
        [
            [-params.leanB_p_d / 2 , params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pF / 12 + offsetVer, -(params.p_d / 2 + offsetCB)],
            [-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + offset, params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pF / 12 + offsetVer, -(params.p_d / 2 + offsetCB)],
            [-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + offset, params.leanB_p_h  + offsetHor, -(params.p_d / 2 + params.leanB_p_w + offsetCB * 2)],
            [-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + offset, 0.2, -(params.p_d / 2 + params.leanB_p_w + offsetCB * 2)],
            [-params.leanB_p_d / 2, 0.2, -(params.p_d / 2 + params.leanB_p_w + offsetCB * 2)],
            [-params.leanB_p_d / 2, params.leanB_p_h  + offsetHor, -(params.p_d / 2 + params.leanB_p_w + offsetCB * 2)],
            [-params.leanB_p_d / 2, params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pF / 12 + offsetVer, -(params.p_d / 2 + offsetCB * 2)],
        ]
    ), [params.leanB_p_d, params.p_d, params.leanB_p_w, params.leanB_p_h, params.b_l_t_r_pF, params.add_storage_back, offset])

    return (
        <>
            <Line
                points={topLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Html occlude position={[(-params.leanB_p_d + parseInt(params.add_storage_back) + offset) / 2, params.leanB_p_h + params.leanB_p_w * params.b_l_t_r_pF / 12 + 0.5 , -params.p_d / 2 - 0.5]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </>
    )
}

export default OutLineSection